var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.cloader.display)?_c('div',{staticClass:"action-loader"},[_c('loader'),_c('span',[_vm._v(_vm._s(_vm.cloader.label))])],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }